import { computed, type ComputedRef } from 'vue'
import { useI18n } from 'vue-i18n'
import { useRoute } from 'vue-router'

export const usePageDescription = (): ComputedRef<string | undefined> => {
  const route = useRoute()
  // eslint-disable-next-line @typescript-eslint/unbound-method -- false positive
  const { t, te } = useI18n()

  return computed(() => {
    for (let i = route.matched.length - 1; i > 0; i--) {
      const match = route.matched[i]
      if (match?.meta?.title) {
        const key = `core.pages.${match.meta.title}.description`

        return te(key) ? t(key) : undefined
      }
    }

    return undefined
  })
}
